'use strict';
import { NotificationTemplateType } from '../../settings/notification-template/notification-template-type.enum';
var UserNotificationBuilder = /** @class */ (function () {
    function UserNotificationBuilder(userNotification) {
        var defaultUserNotification = {
            id: 'b0bb0b0b-b0b0-b0b0-b0b0-b0bb0bb0bb0b',
            creationDate: Date.now() - 3600,
            content: 'bob went on a trip and then he fell',
            type: NotificationTemplateType.TICKET_SUBMITTED,
            uri: 'https://url.com'
        };
        this.userNotification = userNotification || defaultUserNotification;
    }
    UserNotificationBuilder.prototype.withUserId = function (userId) {
        this.userNotification.id = userId;
        return this;
    };
    UserNotificationBuilder.prototype.withCreationDate = function (creationDate) {
        this.userNotification.creationDate = creationDate;
        return this;
    };
    UserNotificationBuilder.prototype.withContent = function (content) {
        this.userNotification.content = content;
        return this;
    };
    UserNotificationBuilder.prototype.withtype = function (type) {
        this.userNotification.type = type;
        return this;
    };
    UserNotificationBuilder.prototype.withuri = function (uri) {
        this.userNotification.uri = uri;
        return this;
    };
    UserNotificationBuilder.prototype.build = function () {
        return this.userNotification;
    };
    return UserNotificationBuilder;
}());
export { UserNotificationBuilder };
//# sourceMappingURL=user-notification-builder.js.map